import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import API_BASE_URL from './config';
import { FaArrowLeft } from 'react-icons/fa';

const MerchantDashboard = () => {
  const navigate = useNavigate();
  const [redeemedCoupons, setRedeemedCoupons] = useState([]);
  const [approvedDeals, setApprovedDeals] = useState([]);
  const [summary, setSummary] = useState(null);


  useEffect(() => {
    const merchantId = localStorage.getItem('merchantId');

    if (!merchantId) {
      console.warn('Merchant not logged in.');
      return;
    }

    fetch(`${API_BASE_URL}/api/merchant/dashboard-summary?merchantId=${merchantId}`)
      .then(res => res.json())
      .then(data => setSummary(data))
      .catch(err => console.error('Error fetching merchant summary:', err));

    fetch(`${API_BASE_URL}/api/merchant/redeemed-coupons?merchantId=${merchantId}`)
      .then(res => res.json())
      .then(data => setRedeemedCoupons(data))
      .catch(err => console.error('Error fetching redeemed coupons:', err));

    fetch(`${API_BASE_URL}/api/merchant/approved-deals?merchantId=${merchantId}`)
      .then(res => res.json())
      .then(data => setApprovedDeals(data))
      .catch(err => console.error('Error fetching approved deals:', err));
  }, []);


  const handleNewDealClick = () => {
    navigate('/create-deal');
  };

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <button className="back-btn" onClick={() => navigate('/merchant-login')}>
          <FaArrowLeft />
        </button>
        <h1>Welcome Merchant</h1>
        <button className="new-deal-btn" onClick={handleNewDealClick}>
          Create New Deal
        </button>
      </header>

      {summary && (
        <section className="deals-list">
          <h2>Sales Summary</h2>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Total Sales</th>
                <th>Deals Completed</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>This Month</td>
                <td>₹{summary.monthSales}</td>
                <td>{summary.monthDeals}</td>
              </tr>
              <tr>
                <td>Overall</td>
                <td>₹{summary.totalSales}</td>
                <td>{summary.totalDeals}</td>
              </tr>
            </tbody>
          </table>
        </section>
      )}

      <section className="deals-list">
        <h2>Redeemed Coupons</h2>
        <table>
          <thead>
            <tr>
              <th>Coupon Code</th>
              <th>Deal Title</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {redeemedCoupons.map(coupon => (
              <tr key={coupon._id}>
                <td>{coupon.couponCode}</td>
                <td>{coupon.dealTitle}</td>
                <td>Redeemed on {coupon.redeemedAt}</td>
                <td>
                  <button className="action-btn">View Details</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      <h2>Approved Deals</h2>
      <div className="approved-deals">
        {approvedDeals.length === 0 ? (
          <p style={{ color: '#888' }}>No approved deals yet.</p>
        ) : (
          <div className="deal-grid">
            {approvedDeals.map((deal) => (
              <div key={deal._id} className="deal-card">
                <img src={`/uploads/${deal.image || 'placeholder.jpg'}`} alt={deal.title} />
                <h3>{deal.title}</h3>
                <p>{deal.description}</p>
                <p><strong>Discount:</strong> {deal.discountValue}%</p>
                <p><strong>Valid till:</strong> {deal.endDate}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MerchantDashboard;